import { CalculatorTypes } from '../enums/calculator-types.enum';
import { CalculatorInput } from '../interfaces/calculator-input.interface';

export class CalculatorHelpers {
  static splitFormula(formula: string): string[] {
    formula = formula.replace(/\s+/, '');
    return formula.match(/({[^{}]+})|\d+|[+\-*/()]/g);
  }

  static getMetricId(metric: string) {
    return metric.match(/\d+/)[0];
  }

  static getValueType(value: string): CalculatorTypes {
    const types = CalculatorTypes;
    if (['*', '/', '-', '+'].includes(value)) {
      return types.OPERATOR;
    } else if (value === '(') {
      return types.OPEN_BRACKET;
    } else if (value === ')') {
      return types.CLOSE_BRACKET;
    } else if (value.includes('metric')) {
      return types.METRIC;
    }
    return types.NUMBER;
  }

  static parseFormula(formula: string, metrics: { id: number; name: string }[]): CalculatorInput[] {
    const parsedFormula = this.splitFormula(formula);
    const types = CalculatorTypes;
    const result: CalculatorInput[] = [];

    parsedFormula.forEach((item) => {
      if (item.includes('metric')) {
        const id = +this.getMetricId(item);
        result.push({ type: types.METRIC, id, value: metrics.find((metric) => metric.id === id).name });
      } else {
        result.push({ type: this.getValueType(item), value: item });
      }
    });

    return result;
  }
}
